<template>
  <div class="container" id="booking">
    <div class="row">
      <div class="col-12">
        <div class="webpage-section-header  text-center" >
          RESERVATION
          <div class="under-bar"></div>
        </div>
      </div>
    </div>
    <div class="row" v-if="merchantItem !== null && merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.booking_message !== undefined && merchantItem.webSetting.booking_message !== null && merchantItem.webSetting.booking_message.length > 0">
      <div class="col-12" v-html="merchantItem.webSetting.booking_message.replace(/\n/g, '<br />')">

      </div>
    </div>
    <div class="row" v-if="bookingTypes.length > 1">
      <div class="col-12 booking-type-container" >
        <div class="booking-type" v-for="type in bookingTypes" v-bind:class="{'selected' : bookingItem !== false && bookingItem.bookingType === type.title}" v-on:click="onTypeSelected(type)">
          <div class="booking-type-title">
            {{type.title}}
          </div>
          <div class="booking-type-description" v-if="type.description !== undefined && type.description !== null && type.description.length > 0">
            {{type.description}}
          </div>
        </div>
      </div>
    </div>
    <template  v-if="bookingItem !== false">
      <div class="row booking-form-row text-left">

        <div class="col-12 text-center" v-if="bookingItem.typeList.length > 0">

          <strong>Table Type Selection</strong>
          <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
            <div v-for="type in bookingItem.typeList" class="round-selector" v-bind:class="{'selected': bookingItem.tableType === type}" v-on:click="selectSubType(type)">{{type}}</div>
          </div>
        </div>
        <div class="col-12 col-md-4">

          Date <span v-if="bookingItem !== null && bookingItem !== false && bookingItem.lastDay !== null">(up to {{bookingItem.lastDay}})</span>
          <div class="white-input" style="border-radius: 0.25rem;">
            <date-picker style="width: 100%; "
                         :lang="'en'"
                         class="date-picker"
                         input-class="date-picker"
                         v-model="bookingItem.bookingDate"
                         typable="false"
                         placeholder="Select Date"
                         valueType="format"
                         @change="onBookingDateSelected"></date-picker>
          </div>
  <!--        <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
        </div>

        <div class="col-12 col-md-4">
          Time
          <select class="form-control" v-model="bookingItem.bookingTime" @change="timeSelected" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">
              <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get time list</span>
              <span v-else>Select Time</span>
            </option>
            <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.time" :disabled="slot.available === false">{{slot.text}}
              <span v-if="slot.available === false">{{slot.message.length > 0?' '+ slot.message:' Full'}}</span>
            </option>
          </select>
        </div>
      </div>

      <div class="row booking-form-row text-left">
        <div class="col-12 col-md-4">
          <span  v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && parseInt(merchantItem.webSetting.bookingChildrenEnabled) === 1">
          Number of Adults (over 10 years old)
          </span>
          <span v-else>
            Number of Guests
          </span>
          <select class="form-control" v-model="bookingItem.headCount" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">
              <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get capacity</span>
              <span v-else>Number of Guests </span>
            </option>
            <template v-for="(c, ci) in bookingItem.maxBooking">
              <option v-if="c > 1 && c >= bookingItem.minBooking" :value="c">{{c}} Adults</option>
            </template>
          </select>
        </div>
        <div class="col-12 col-md-4" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && parseInt(merchantItem.webSetting.bookingChildrenEnabled) === 1">
          Number of children (5~10 years old)
          <select class="form-control" v-model="bookingItem.children" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">No children
            </option>
            <template v-for="(c, ci) in 10">
              <option :value="c">{{c}} Child<span if="c > 1">ren</span></option>
            </template>
          </select>
        </div>
        <div class="col-12 col-md-4">
          Number of toddlers ( age of 4 or under)
          <select class="form-control" v-model="bookingItem.infants" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">No Toddlers
            </option>
            <template v-for="(c, ci) in 10">
              <option :value="c">{{c}} Toddler<span v-if="c > 1">s</span></option>
            </template>
          </select>
        </div>
      </div>
      <div class="row booking-form-row text-left">
        <div class="col-12 col-md-4">
          Name
          <input class="form-control" type="text" v-model="bookingItem.name" placeholder="Name">
        </div>
        <div class="col-12 col-md-4">
          Mobile Number
          <input class="form-control" type="text" v-model="bookingItem.contact" placeholder="Mobile Number">
        </div>

        <div class="col-12 col-md-6">
          Email (Verification code will be sent)
          <input class="form-control" type="text" v-model="bookingItem.email" placeholder="Email">

        </div>
        <div class="col-12 col-md-6">
          <div>Email confirmation</div>
          <input class="form-control" type="text" v-model="bookingItem.emailConfirm" placeholder="Email Confirmation">

        </div>
        <div class="col-12">
          <span style="color:red;">* Incorrect email will prevent us from sending you confirmation or notification email</span>
        </div>
        <div class="col-12 text-left">
          Special Request
          <textarea class="form-control" rows="3" v-model="bookingItem.note" placeholder="Special Request"/>
        </div>
        <div class="col-12 text-left">
          <span v-if="bookingItem.allowMerchantPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="far fa-square"></i></span>
           {{merchantItem.title}} will send you offers or news by email unless you object by unchecking this box.
        </div>
        <div class="col-12 text-left">
          <span v-if="bookingItem.allowSmtmPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="far fa-square"></i></span>
          Show Me The Menu will send you offers and news by email unless you object by unchecking this box.
        </div>
        <div class="col-12 text-center" v-if="bookingItem.deposit > 0">
          <strong>
            <span style="color:red;">Deposit of £{{(bookingItem.deposit/100.0).toFixed(2)}} is required for this date.</span>
            <br/>
            Credit Card Pre Authorisation will be processed after submission and email verification.
          </strong>
        </div>
        <div class="col-12 text-center">

          <div class="text-center">
            <br/>Submission will send a verification code to your email address to complete reservation request.
            <br/>Once email is verified, reservation request will be sent to restaurant.
            <br/>Otherwise, restaurant will not receive any information about reservation request.
          </div>
        </div>
        <div class="col-12 text-center">
          <button class="btn gray-submit-button" v-bind:class="{'enabled-black': canSubmitBooking(false) === true}" v-on:click="submitBooking">Submit</button>
        </div>
      </div>
    </template>
    <div v-if="verifyItem !== false" style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.4); z-index: 2;">
      <div style="position:absolute; top:50%; left:50%; width: 90%; max-width: 400px;  transform: translate(-50%, -50%); background-color: white; border-radius: 10px;">
        <div class="container" style="padding-top: 50px; padding-bottom: 50px;">
          <div class="row">
            <div class="col-12" style="padding-top:20px; font-size: 15px;line-height: 20px;">
              We sent you verification code to your email.
              <br/>
              Enter the verification code and click "verify" button to complete reservation request
              <br/>
              If you cannot find email, please check spam folder.
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="padding-top: 20px;">
              <input class="form-control text-center" style="font-size: 30px;" v-model="verifyItem.code"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="padding-top: 20px;">
              <button class="btn btn-primary form-control" v-on:click="verifyCode">VERIFY</button>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="padding-top: 20px;">
              Make sure to set as "Not Spam" if you found email from spam folder.
              <br>
              <span style="color:red;">This verification code is not a code for your booking confirmation</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
  import {
    getBookingTimeTable,
    getBookingTypes,
    getHolidayList,
    getUnavailableBookingTime,
    submitBooking, verifyBookingItemEmailAddress,
    bookingCardDepositPreAuthorise
  } from "../api/borium";
  import {millisToDate, millisToHM} from "../api/utils";
  import EventBus from "../api/event-bus";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import axios from "axios";
    export default {
      name: "BookingView",
      props: {
        merchantItem: {
          type:Object,
          default: function(){return false},
        },
      },
      components: {
        DatePicker
      },
      data() {
        return {
          bookingItem:false,
          bookingDaySchedules: [],
          bookingTypes:[],
          holidays:[],
          verifyItem: false,
          stripe:false,
        }
      },
      created() {
      },
      mounted() {
        if(this.merchantItem !== false) {
          this.getBookingInfo();
          // console.log("booking view");
          // console.log(this.merchantItem);
        }
      },
      methods: {
        getBookingInfo: function() {
          let self = this;
          // console.log(this.merchantItem.merchantId);
          getBookingTypes(this.merchantItem.merchantId)
            .then(function(data){
              // console.log("booking type")
              // console.log(data);
              if(data.success === true) {
                self.$data.bookingTypes = data.item;
              }
              self.getBookingTimes();
            })
            .catch(function(err) {

            })
        },
        getBookingTimes: function() {
          let self = this;
          getBookingTimeTable(this.merchantItem.merchantId)
            .then(function(data) {
              if(data.success === true) {
                self.$data.bookingDaySchedules = data.item;
                // console.log(data.item);

                if(self.$data.bookingTypes.length === 1) {
                  self.$data.bookingItem = {
                    bookingDate:'',
                    bookingDayTime:'',
                    bookingTime:0,
                    bookingType:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].title : '',
                    name:'',
                    headCount:0,
                    children:0,
                    email:'',
                    emailConfirm:'',
                    note:'',
                    contact:'',
                    subscriptionId:self.merchantItem.merchantId,
                    slots:[],
                    types:[],
                    tableType:'',
                    typeList:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].types : [],
                    maxBooking: 6,
                    minBooking: 2,
                    deposit:0,
                    cancellableTime:0,
                    lastDay:null,
                    allowMerchantPromotion:true,
                    allowSmtmPromotion:true,
                  }

                  if(self.$data.bookingTypes[0].maxBooking > 0) {
                    self.$data.bookingItem.maxBooking = self.$data.bookingTypes[0].maxBooking;
                  }
                  if(self.$data.bookingTypes[0].minBooking > 0) {
                    self.$data.bookingItem.minBooking = self.$data.bookingTypes[0].minBooking;
                  }
                  if(self.$data.bookingTypes[0].slotLength > 0) {
                    let lastDay = new Date();
                    lastDay.setDate(lastDay.getDate() + self.$data.bookingTypes[0].slotLength);
                    self.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
                  }
                }

                self.getHolidayList();
              }

            })
            .catch(function(err) {

              // console.log(err);
              // if(err.response !== undefined) {
              //   console.log(err.response);
              // }
            })
        },
        getHolidayList: function() {
          // console.log("get holiday list");
          let self = this;
          let today = millisToDate(new Date().getTime(), '-');

          getHolidayList(this.merchantItem.merchantId, today)
            .then(function(data) {
              // console.log("holiday response");
              // console.log(data);
              if(data.success === true) {
                self.$data.holidays = data.item;
              }
            })
            .catch(function(err) {
              // console.log(err);
              // if(err.response !== undefined) {
              //   console.log(err.response);
              // }
            })
        },
        canSubmitBooking: function(showDialog = true) {
          if(this.$data.bookingItem == null || this.$data.bookingItem === false) {

            return false;
          }

          if(this.$data.bookingItem.typeList !== null && this.$data.bookingItem.typeList.length > 0 && (this.$data.bookingItem.types === null || this.$data.bookingItem.types.length === 0)) {
            if(showDialog) this.showDialog("Please select table type");
            return false;
          }
          let todayText = millisToDate();
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00'
            ||this.$data.bookingItem.bookingDate < todayText ) {
            if(showDialog) this.showDialog("Date cannot be earlier than today");
            return false;
          }

          if(this.$data.bookingItem.bookingTime === 0) {
            if(showDialog) this.showDialog("Please select time");
            return false;
          }

          if(this.$data.bookingItem.name === null || this.$data.bookingItem.name === '' || this.$data.bookingItem.name.length < 2) {
            if(showDialog) this.showDialog("Please enter your name");
            return false;
          }
          if(this.$data.bookingItem.headCount === 0) {
            if(showDialog) this.showDialog("Please enter number of people");
            return false;
          }
          if(this.$data.bookingItem.contact === null || (this.$data.bookingItem.contact.startsWith("44") === false && this.$data.bookingItem.contact.startsWith("07") === false)) {
            if(showDialog) this.showDialog("Please enter phone number. Should be 07********* and 11 digits");
            return false;
          }
          if(this.$data.bookingItem.email === null || this.$data.bookingItem.email.includes("@") === false) {
            if(showDialog) this.showDialog("Please enter correct email address");
            return false;
          }
          if(this.$data.bookingItem.emailConfirm == null || this.$data.bookingItem.emailConfirm.includes("@") === false) {
            if(showDialog) this.showDialog("Please enter confirmation email");
            return false;
          }
          if(this.$data.bookingItem.email !== this.$data.bookingItem.emailConfirm) {
            if(showDialog) this.showDialog("Email addresses are not matching");
            return false;
          }
          // console.log("submittable")
          return true;
        },
        submitBooking: function() {
          if(this.canSubmitBooking()==false) {
            return;
          }

          for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
            if(this.$data.bookingItem.slots[i].time === this.$data.bookingItem.bookingTime) {
              this.$data.bookingItem.bookingDayTime = this.$data.bookingItem.slots[i].text;
              break;
            }
          }

          // console.log("submit")
          // console.log(this.$data.bookingItem);
          EventBus.$emit("showLoading", true, "Submitting...");
          let self = this;
          submitBooking(this.$data.bookingItem)
            .then(function(data) {
              EventBus.$emit("showLoading", false);
              if(data.success === true) {

                self.$data.verifyItem = {
                  item:data.item,
                  code:'',
                }

                self.$data.bookingItem = {
                  bookingDate:'',
                  bookingDayTime:'',
                  bookingTime:0,
                  name:'',
                  headCount:0,
                  children:0,
                  infants:0,
                  email:'',
                  emailConfirm:'',
                  note:'',
                  contact:'',
                  subscriptionId:self.merchantItem.merchantId,
                  slots:[],
                  types:[],
                  tableType:'',
                  typeList:[],
                  deposit:0,
                  cancellableTime:0,
                  allowMerchantPromotion:true,
                  allowSmtmPromotion:true,
                }
              } else {
                self.showDialog(data.message);
              }
            })
            .catch(function(err) {
              EventBus.$emit("showLoading", false);

              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
              self.showDialog("There was an error. Please check email if you received email.", "Something went wrong!");
            })
        },
        verifyCode: function() {
          if(this.$data.verifyItem.code === null || this.$data.verifyItem.code.length !== 6) {
            this.showDialog("Please enter 6 digit verification code");
            return;
          }

          let self = this;
          verifyBookingItemEmailAddress(this.$data.verifyItem.item.id, this.$data.verifyItem.code)
          .then(function(data) {
            if(data.success === true) {
              self.$data.verifyItem = false;
              if(data.item.deposit > 0) {
                self.processToPayDeposit(data.item.id);
                return;
              }
              let msg = '<div style="font-size:15px;"><hr/>';
              msg += '<span style="color:red;">We will send you a confirmation email to inform you that the reservation has been accepted or rejected.</span>';
              msg += '<br/>If your reservation needs to be changed we will let you know.';
              msg += '<br/><hr/>';
              msg += 'Please keep an eye out on your Spam folder just in case.';
              msg += '<br/>If you do not receive any email from us or need any further help, please contact restaurant.';
              if(self.merchantItem.contact !== null) {
                msg += '<br/><strong>'+self.merchantItem.title + '<br/>Tel:' + self.merchantItem.contact + '<br/>' + self.merchantItem.address.replace(/\n/g, '<br />') + '</strong>';
              }
              msg += '<br/><hr/>';
              msg += '<span style="color:red;">Your reservation is NOT confirmed yet. Please wait for confirmation email</span>';
              msg += '<br/>Thank you</div>';
              self.showDialog(msg, "Your booking request has been submitted.");
              self.getBookingInfo();
            } else {
              self.showDialog(data.message);
            }

          })
          .catch(function(err) {
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }
            self.showDialog("Error occurred", "OOPS");
          })
        },
        processToPayDeposit: function(id) {
          let self = this;
          bookingCardDepositPreAuthorise(id)
          .then(function(data) {
            // console.log("booking card deposit");
            // console.log(data);
            if(data.success === true) {
              self.startStripPayment(data.item, data.message);
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }
          })
        },
        startStripPayment: function(item, key) {
          // this.$data.stripe = Stripe('pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN');
          // console.log("start stripe payment " + key);
          this.$data.stripe = Stripe(key);
          this.$data.stripe.redirectToCheckout({ sessionId: item.stripeSessionId });

        },
        selectSubType: function(type) {
          this.$data.bookingItem.types = [type];
          this.$data.bookingItem.tableType = type;
        },
        isTypeSelected: function(type) {

          for(let i = 0 ; i < this.$data.bookingItem.types.length ; i++) {
            if(this.$data.bookingItem.types[i] === type) {
              return true;
            }
          }
          return false;
        },
        onTypeSelected: function(type) {
          if(type === this.$data.bookingItem.bookingType) {
            return;
          }
          this.$data.bookingItem = {
            bookingDate:'',
            bookingDayTime:'',
            bookingTime:0,
            bookingType:'',
            name:'',
            headCount:0,
            children:0,
            infants:0,
            email:'',
            emailConfirm:'',
            note:'',
            contact:'',
            subscriptionId:this.merchantItem.merchantId,
            slots:[],
            types:[],
            tableType:'',
            typeList:this.$data.bookingTypes.length === 1 ? this.$data.bookingTypes[0].types : [],
            maxBooking: 20,
            deposit:0,
            cancellableTime:0,
            lastDay:null,
            allowMerchantPromotion:true,
            allowSmtmPromotion:true,
          }
          this.$data.bookingItem.bookingType = type.title;
          this.$data.bookingItem.bookingDate = "";
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.$data.bookingItem.bookingEndTime = 0;
          this.$data.bookingItem.types = [];
          this.$data.bookingItem.deposit = 0;
          this.$data.bookingItem.typeList = type.types;
          this.$data.bookingItem.maxBooking = type.maxBooking > 0?type.maxBooking:20;
          this.$data.bookingItem.minBooking = type.minBooking > 0?type.minBooking:2;
          this.$data.bookingItem.cancellableTime = 0;
          this.$data.bookingItem.lastDay = null;

          if(type.slotLength > 0) {
            let lastDay = new Date();
            lastDay.setDate(lastDay.getDate() + type.slotLength);
            this.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
          }

        },

        onBookingDateSelected: function() {
          let todayText = millisToDate();
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00'
            ||this.$data.bookingItem.bookingDate < todayText ) {
            this.showDialog("The earliest date you can select is today.");
            this.$data.bookingItem.bookingDate = '';
            return false;
          }
          if(this.$data.bookingItem.lastDay !== null && this.$data.bookingItem.lastDay !== false && this.$data.bookingItem.bookingDate > this.$data.bookingItem.lastDay) {
            this.showDialog("The last day you can book is " + this.$data.bookingItem.lastDay);
            this.$data.bookingItem.bookingDate = '';
            return;
          }


          // console.log("Holiday list");
          // console.log(this.$data.holidays);
          if(this.$data.holidays.length > 0) {
            for(let i = 0 ; i < this.$data.holidays.length ; i++) {
              if(this.$data.holidays[i].startDate <= this.$data.bookingItem.bookingDate && this.$data.holidays[i].endDate >= this.$data.bookingItem.bookingDate) {
                let msg = this.$data.bookingItem.bookingDate + " is not available<br>";
                if(this.$data.holidays[i].title !== undefined && this.$data.holidays[i].title !== null && this.$data.holidays[i].title.length > 0) {
                  msg += this.$data.holidays[i].title + "<br>";
                }
                msg += "Please select different date<br><br>";
                this.showDialog(msg);
                this.$data.bookingItem.bookingDate = '';
                return;
              }
            }
          }
          let selectedDay = new Date(this.$data.bookingItem.bookingDate).getDay();

          // console.log("selected day " + selectedDay);
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.$data.bookingItem.bookingEndTime = 0;
          this.$data.bookingItem.headCount = 0;
          this.$data.bookingItem.children = 0;
          this.$data.bookingItem.infants = 0;
          this.$data.bookingItem.deposit = 0;
          this.$data.bookingItem.duration = 0;
          this.$data.bookingItem.cancellableTime = 0;


          // console.log("all schedule");
          // console.log(this.$data.bookingDaySchedules);
          let day = this.$data.bookingDaySchedules[selectedDay];

          if(day.open === false) {

            this.showDialog("Please select different date as " + this.$data.bookingItem.bookingDate + " is closed");
            this.$data.bookingItem.bookingDate = '';
            return;
          }
          if(day.available === false) {
            if(day.unavailableMessage !== undefined && day.unavailableMessage !== null && day.unavailableMessage.length > 0) {
              this.showDialog("Please select different date<br/>" + day.unavailableMessage);
            } else {
              this.showDialog("Please select different date<br/>Reservation on this date is not available.");
            }

            this.$data.bookingItem.bookingDate = '';
            return;
          }
          let available = false;
          let message = "No available slot found. Please try different date";
          for(let i = 0 ; i < day.list.length ; i++) {
            if (day.list[i].itemType === this.$data.bookingItem.bookingType) {
              if(day.list[i].available === true) {
                available = true;
                break;
              } else if(day.list[i].unavailableMessage !== null && day.list[i].unavailableMessage.length > 0 ){
                message = day.list[i].unavailableMessage;
              }
            }
          }

          if(available === false) {
            this.showDialog(message);
            this.$data.bookingItem.bookingDate = '';
            return;
          }
          // console.log("selected day");
          // console.log(day);
          let timeNow = new Date().getTime();

          if(day.deposit > 0) {

            let diff = (new Date(this.$data.bookingItem.bookingDate).getTime() - timeNow)/(1000*60*60*24);

            if(diff > 5) {
              let earliestDate = new Date(this.$data.bookingItem.bookingDate).getTime() - (5*1000*60*60*24);


              this.showDialog("Reservation for " + this.$data.bookingItem.bookingDate + " can be booked from "+ new Date(earliestDate).toLocaleDateString());
              this.$data.bookingItem.bookingDate = "";
              return;
            }



            this.$data.bookingItem.deposit = day.deposit;


          }
          // console.log(this.$data.bookingTypes);
          this.$data.bookingItem.maxBooking = 20;
          this.$data.bookingItem.minBooking = 2;
          for(let i = 0 ; i < this.$data.bookingTypes.length ; i++) {
            if(this.$data.bookingTypes[i].title === this.$data.bookingItem.bookingType) {
              if(this.$data.bookingTypes[i].maxBooking > 0) {
                this.$data.bookingItem.maxBooking = this.$data.bookingTypes[i].maxBooking;
              }
              if(this.$data.bookingTypes[i].minBooking > 0) {
                this.$data.bookingItem.minBooking = this.$data.bookingTypes[i].minBooking;
              }
              break;
            }
          }
          // this.$data.bookingItem.maxBooking = this.$data.bookingItem.bookingType.maxBooking > 0?this.$data.bookingItem.bookingType.maxBooking:20;
          // this.$data.bookingItem.minBooking = this.$data.bookingItem.bookingType.minBooking > 0?this.$data.bookingItem.bookingType.minBooking:2;
          if(day.maxCount > 0) {
            this.$data.bookingItem.maxBooking = day.maxCount;
          }

          // console.log("selected day with type " + this.$data.bookingItem.bookingType);
          // console.log(day.list);
          for(let i = 0 ; i < day.list.length ; i++) {
            if(day.list[i].itemType !== this.$data.bookingItem.bookingType) {
              continue;
            }
            let cutOffTime = 0;
            if(day.list[i].minTime > 0) {
              cutOffTime = day.list[i].minTime*60000;
            }
            // console.log(day.list[i]);
            let dayObj = new Date(this.$data.bookingItem.bookingDate);
            dayObj.setHours(day.list[i].startHour, day.list[i].startMinute);
            let timeSlot = dayObj.getTime();
            let endObj = new Date(this.$data.bookingItem.bookingDate);
            endObj.setHours(day.list[i].endHour, day.list[i].endMinute);
            let endSlot = endObj.getTime();
            while(timeSlot <= endSlot) {
              let newSlot = {
                time:timeSlot,
                text: millisToHM(timeSlot),
                available:day.list[i].available,
                cancellableTime: 0,
                length:day.list[i].length,
                message:day.list[i].available === false?'Walk-in only':'',
              }
              if(day.deposit > 0 && day.cancellableTime > 0 ) {
                newSlot.cancellableTime = timeSlot - (day.cancellableTime * 60 * 60000);
              }

              // Check if min time is meeting
              if(timeSlot - cutOffTime > timeNow) {
                this.$data.bookingItem.slots.push(newSlot);
              }
              // console.log("add new slot");
              // console.log(newSlot);

              timeSlot += day.list[i].slotLength * 60000;
            }
          }
          if(this.$data.bookingItem.slots.length == 0) {
            this.showDialog("Please selected different date as there is no available time slots");
            this.$data.bookingItem.bookingDate = "";
            return;
          }
          this.getUnavailableList();

          // console.log(this.$data.bookingItem.slots);
        },
        timeSelected: function() {
          this.$data.bookingItem.cancellableTime = 0;
          for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
            if(this.$data.bookingItem.bookingTime === this.$data.bookingItem.slots[i].time) {
              this.$data.bookingItem.cancellableTime = this.$data.bookingItem.slots[i].cancellableTime;
              this.$data.bookingItem.duration = this.$data.bookingItem.slots[i].length;
              this.$data.bookingItem.bookingEndTime = this.$data.bookingItem.bookingTime+(this.$data.bookingItem.slots[i].length*60000);
              return;
            }
          }
        },
        getUnavailableList: function() {
          let self = this;
          getUnavailableBookingTime(this.merchantItem.merchantId, this.$data.bookingItem.bookingDate)
            .then(function(data) {

              // console.log("unavailable list");
              // console.log(data);
              if(data.success === true) {
                for(let i = 0 ; i < data.item.length ; i++) {
                  for(let j = 0 ; j < self.$data.bookingItem.slots.length ;j++) {
                    if(self.$data.bookingItem.slots[j].time >= data.item[i].startTime && self.$data.bookingItem.slots[j].time < data.item[i].endTime) {
                      self.$data.bookingItem.slots[j].available = false;
                    }
                  }
                }

                let availableSlotsFound = false;
                for(let i = 0 ; i < self.$data.bookingItem.slots.length ; i++) {
                  if(self.$data.bookingItem.slots[i].available == true) {
                    availableSlotsFound = true;
                    break;
                  }
                }
                if(availableSlotsFound === false) {
                  self.$data.bookingItem.bookingDate = '';
                  self.showDialog("Please select different date as no slots available for " + self.$data.bookingItem.bookingDate);
                }
              }
            })
            .catch(function(err) {

              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },
        showDialog: function(message, title = '') {
          let params = {
            title:title,
            text:message
          }
          this.$modal.show('dialog', params);
        }
      }
    }
</script>

<style scoped>
.booking-form-row input, select, select:disabled {
  height: 62px;
  line-height: 64px;
  border: none;
  background-color: white;

}
select option:first-of-type {
  color: red;
}
.booking-form-row textarea {
  border: none;
}
.white-input {
  height: 62px;
  background-color: #FFF;
  padding:12px 0;
}
.date-picker {
  border: unset;
  background-color: white;
  padding-left: 10px;
}

.gray-submit-button {
  background: #ABABAB;
  color: white;
  padding: 18px 84px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;


  text-align: center;
  letter-spacing: 0.1em;
  border-radius: 10px;
}
.enabled-black {
  background-color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingView.vue